import { render, staticRenderFns } from "./legalPage.vue?vue&type=template&id=6d84c47c&scoped=true"
import script from "./legalPage.vue?vue&type=script&lang=js"
export * from "./legalPage.vue?vue&type=script&lang=js"
import style0 from "./legalPage.vue?vue&type=style&index=0&id=6d84c47c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d84c47c",
  null
  
)

export default component.exports